export const PortalViewId = {
  PropertiesList: 'properties.list',
} as const;

export type PortalViewId = (typeof PortalViewId)[keyof typeof PortalViewId];
